export const STAGE_KEY = 'conversion';

export const STAGE_CONFIG = {
  id: 'fase4',
  label: 'Conversion digital',
  questionOrder: [
    'requestedService',
    'prospectos',
    'ticket',
    'productionCost',
    'newClients',
    'presupuestoMesa',
    'marketCpl',
    'qualifiedCpl',
    'userEmail',
    'userPhone',
  ],
  coreFields: [
    'requestedService',
    'presupuestoMesa',
    'ticket',
    'productionCost',
    'closeRate',
    'marketCpl',
    'qualifiedCpl',
    'userEmail',
    'userPhone',
  ],
  serviceIds: ['conv-diagnostico', 'conv-scripts', 'conv-propuesta', 'conv-setter', 'conv-confirmacion', 'conv-cierre'],
  questions: {
    requestedService: '¡Excelente, {userName}! Vamos a pulir su cierre. ¿Que area quiere potenciar hoy: mejorar sus guiones, el proceso de propuesta formal o tener un equipo de setters digitales?',
    prospectos: '¿Cuantas oportunidades o reuniones reales logra agendar hoy al mes y por que canal suelen entrar a su embudo?',
    ticket: 'Para dimensionar el valor de cada cierre ({offer}), ¿que valor tiene su ticket promedio comercial?',
    productionCost: '¿Cuanto le cuesta a nivel operativo cumplir con lo prometido en la venta?',
    newClients: '¿Cuantos cierres nuevos al mes necesita para que este salto de conversion valga la pena?',
    presupuestoMesa: '¿Que presupuesto puede destinar para profesionalizar su flujo comercial y de cierres?',
    marketCpl: '¿Tiene el dato de cuánto le está costando captar un prospecto básico actualmente?',
    qualifiedCpl: 'De esos prospectos, ¿cuánto le termina costando generar una oportunidad real o reunión calificada?',
    userEmail: 'Ya casi terminamos. Para mandarle su análisis detallado, ¿a qué correo se lo comparto?',
    userPhone: 'Y por si se corta la conexión antes de darle sus resultados, ¿cuál es su WhatsApp o número de contacto?',
  },
};

const conversionGuide = {
  role: 'Asesor de conversion comercial.',
  detectWhen: [
    'El usuario pide vender mejor, cerrar mas, mejorar propuestas, setter o seguimiento comercial.',
  ],
  firstQuestions: [
    'Que busca exactamente: cierres, setter, propuestas, mejor seguimiento comercial o reducir no-show?',
  ],
  thenAsk: [
    'Donde se cae hoy la venta mas frecuentemente?',
    'Cuanto vale su ticket promedio de cierre?',
    'Cuanto le cuesta cumplir lo vendido operativamente?',
    'Cuantas oportunidades reales tienen al mes y que porcentaje cierran?',
    'Con cuanto presupuesto real cuentan para esta mejora comercial?',
  ],
  avoidForNow: [
    'No insistas en trafico si el problema real es que las oportunidades ya se caen en venta.',
  ],
  mustExplain: [
    'Aqui el objetivo es reducir fugas y elevar el paso de reunion a cierre.',
  ],
  services: [
    'Diagnostico del proceso comercial',
    'Scripts y respuestas por objecion',
    'Estructura de propuesta comercial',
    'Sistema de setter digital',
    'Confirmacion y no-show control',
    'Proceso de propuesta y cierre',
  ],
};

export default conversionGuide;
